import { render, staticRenderFns } from "./LouverItems.vue?vue&type=template&id=81360e20&scoped=true&"
import script from "./LouverItems.vue?vue&type=script&lang=js&"
export * from "./LouverItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81360e20",
  null
  
)

export default component.exports